/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
import React from 'react'
import { connect } from 'react-redux'
import { Button } from '@material-ui/core'

import IntentsAutocomplete from './IntentsAutocomplete'
import EntityEditor from './EntityEditor'

import './index.scss'

class DetailsEditor extends React.Component {
    constructor(props) {
        super(props)

        this.state = { requestData: {} }
    }

    componentDidMount() {
        const { classifierResponse } = this.props
        console.log('NLP RESPONSE =>', classifierResponse)

        let clsResponse
        if (classifierResponse) {
            clsResponse = JSON.parse(classifierResponse)
        }

        const intents = []
        const selectedIntents = {}
        if (!clsResponse || (clsResponse && !clsResponse.intents)) {
            // pass
        } else {
            clsResponse.intents.forEach(obj => {
                intents.push({ label: obj.intent, value: obj.intent })
                selectedIntents[obj.intent] = this.formatDatetimeEntity(
                    obj.entities
                )
            })
            // clsResponse.intents.forEach(item => { selectedIntents[item.intent] = item.entities })
        }
        this.handleIntentsChange(intents)

        this.setState({ clsResponse, requestData: selectedIntents })
    }

    formatDatetimeEntity(entities) {
        entities.forEach((entity, i) => {
            if (entity.entity === 'dateTime') {
                entities[i].value = entities[i].value.substr(0, 16)
                entities[i].actual = entities[i].actual.substr(0, 16)
            }
        })
        return entities
    }

    submitIntents() {
        console.log('FINISH ---->', this.state.requestData)
        const { requestData } = this.state

        if (!requestData) {
            return
        }

        this.props.submitIntents(requestData)
        this.props.closePopup()
    }

    requestDataHandler(data) {
        this.setState({ requestData: data })
    }

    handleIntentsChange(intents) {
        console.log('STATE IN HANDLE ->', this.state)
        if (!intents) {
            this.setState({ requestData: [] })
            return
        }
        const updatedData = {}
        intents.map(intent => {
            updatedData[intent.value] = this.state.requestData[intent.value] || []
            return intent
        })
        console.log('updatedData ->', updatedData)
        this.setState({ requestData: updatedData })
    }

    render() {
        const { clsResponse, requestData } = this.state
        const intentEntityConfig = this.props.intentEntityMap.config

        const getIntentsList = () => {
            const intents = []
            if (!clsResponse || (clsResponse && !clsResponse.intents)) {
                return intents
            }

            clsResponse.intents.forEach(obj => {
                intents.push({ label: obj.intent, value: obj.intent })
            })

            return intents
        }

        console.log('REQ DATA', requestData)

        return (
            <div
                className='DetailsEditor'
                style={
                    {
                        // top: (this.props.messageBlockHeight + 10) + 'px',
                        // left: this.props.messageBlockLeft + 'px'
                    }
                }
            >
                {clsResponse && (
                    <div>
                        <IntentsAutocomplete
                            intents={Object.keys(
                                intentEntityConfig.intent_entity_map
                            ).map(item => ({ label: item, value: item }))}
                            defaultValues={getIntentsList()}
                            onChange={intents => this.handleIntentsChange(intents)
                            }
                        />
                    </div>
                )}
                <div className='DetailsEditor__intents'>
                    {Object.keys(requestData).map(intent => (
                        <EntityEditor
                            key={intent + 'wrapper'}
                            intent={intent}
                            requestDataHandler={data => this.requestDataHandler(data)
                            }
                            selectedIntents={requestData}
                            selectedEntities={requestData[intent]}
                            intentEntityConfig={intentEntityConfig}
                        />
                    ))}
                </div>
                <div className='DetailsEditor__actions'>
                    <Button
                        size='small'
                        onClick={() => this.props.closePopup()}
                    >
                        Cancel
                    </Button>
                    <Button size='small' onClick={() => this.submitIntents()}>
                        Try it
                    </Button>
                </div>
                <div className='DetailsEditor__background'></div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    intentEntityMap: state.operatorDashboard.intentEntityMap,
})

export default connect(mapStateToProps)(DetailsEditor)
